import React from 'react';
import InsightsDateRangeFilter from './InsightsDateRangeFilter';
import {
    BundleFilterOptions,
    MatchBundleFilterSelection,
    matchCountLabel,
} from './insightsMatchBundleFilters';
import InsightsMultiSelectDropdown from './InsightsMultiSelectDropdown';

interface Props {
    options: BundleFilterOptions;
    filters: MatchBundleFilterSelection;
    onChange: (next: MatchBundleFilterSelection) => void;
    /** Filtered match count shown top-right (0 allowed). */
    matchCount: number;
}

/**
 * Shared Competition / Date / Match filter bar for Players list + profile + Team.
 * null = all in a dimension; [] = none (Clear). Match count is always visible.
 */
const InsightsScopeFilters: React.FC<Props> = ({ options, filters, onChange, matchCount }) => {
    const competitionIds = filters.competitionIds ?? null;
    const matchIds = filters.matchIds ?? null;
    const showCompetitions = options.competitions.length > 0;
    const showDates = options.dates.length > 0;
    const showMatches = options.matches.length > 0;

    return (
        <div className="insightsScopeFilters">
            <div className="insightsScopeFiltersControls">
                {showCompetitions ? (
                    <InsightsMultiSelectDropdown
                        label="Competition"
                        options={options.competitions.map((c) => ({
                            value: c.id,
                            label: c.name,
                        }))}
                        selected={competitionIds}
                        onChange={(next) => onChange({ ...filters, competitionIds: next })}
                    />
                ) : null}
                {showDates ? (
                    <InsightsDateRangeFilter
                        dateFrom={filters.dateFrom}
                        dateTo={filters.dateTo}
                        onChange={(next) =>
                            onChange({
                                ...filters,
                                dateFrom: next.dateFrom,
                                dateTo: next.dateTo,
                            })
                        }
                    />
                ) : null}
                {showMatches ? (
                    <InsightsMultiSelectDropdown
                        label="Match"
                        options={options.matches.map((m) => ({
                            value: m.id,
                            label: m.label,
                        }))}
                        selected={matchIds}
                        onChange={(next) => onChange({ ...filters, matchIds: next })}
                        listClassName="insightsMultiSelectListTall"
                    />
                ) : null}
            </div>
            <div className="insightsScopeMatchCount" aria-live="polite">
                {matchCountLabel(matchCount)}
            </div>
        </div>
    );
};

export default InsightsScopeFilters;
